/* eslint-disable no-unused-vars */
// import axios from "axios";
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";
import { isEmptyObj } from "../../utils/helper";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class Gohonzon {
  static forwardGohonzon({ data, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/gohonzons/${memberId}/forward`, {
      accessToken: accessTokenFromLocal,
      data: {
        areaId: data.areaId,
        zoneId: data.zoneId,
        regionId: data.regionId,
        chapterId: data.chapterId,
        districtId: data.districtId,
      },
    });

    Gohonzon.forwardGohonzon.cancel = request.cancel;
    return request;
  }

  static searchMembers(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/gohonzons/search`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.searchMembers.cancel = request.cancel;
    return request;
  }

  static initiateGohonzonApplication(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/gohonzonApplications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.initiateGohonzonApplication.cancel = request.cancel;
    return request;
  }

  static gohonzonVerification(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/applications/${applicationId}/verification`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.gohonzonVerification.cancel = request.cancel;
    return request;
  }

  static gohonzonOtpVerification(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/applications/${applicationId}/otp_verification`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.gohonzonOtpVerification.cancel = request.cancel;
    return request;
  }

  static createBatchByRegion(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/gohonzons/application-batches", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.createBatchByRegion.cancel = request.cancel;
    return request;
  }

  static allotApplication(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/applications/${applicationId}/allotment`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.allotApplication.cancel = request.cancel;
    return request;
  }

  static getAllBatches(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/gohonzons/application-batches", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.createBatchByRegion.cancel = request.cancel;
    return request;
  }

  static async getApplicationsByBatchId(data, batchId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");

    try {
      const batchResponse = await get(
        `/api/gohonzons/application-batches/${batchId}`,
        {
          accessToken: accessTokenFromLocal,
          data,
        }
      );

      const content = batchResponse?.data?.content || [];

      const updatedContent = await Promise.all(
        content.map(async (item) => {
          if (item.memberId) {
            try {
              const memberResponse = await post("/api/members/search", {
                accessToken: accessTokenFromLocal,
                data: {
                  memberId: item.memberId,
                  inOrganisationStructure: true,
                },
                params: {
                  size: 10,
                  page: 0,
                },
              });

              const positions =
                memberResponse?.data?.content?.[0]?.positions || [];

              return {
                ...item,
                memberDetails: {
                  ...item.memberDetails,
                  positions,
                },
              };
            } catch (err) {
              console.error(
                `❌ Error fetching positions for memberId ${item.memberId}`,
                err
              );
              return item;
            }
          }
          return item;
        })
      );

      const finalResponse = {
        ...batchResponse,
        data: {
          ...batchResponse.data,
          content: updatedContent,
        },
      };

      return finalResponse;
    } catch (error) {
      console.error("❌ Error in getApplicationsByBatchId:", error);
      throw error;
    }
  }

  static getGohonzonApplications(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/gohonzons/applications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getGohonzonApplications.cancel = request.cancel;
    return request;
  }

  static gohonzonView(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/gohonzons/${data}`, {
      accessToken: accessTokenFromLocal,
    });

    Gohonzon.gohonzonView.cancel = request.cancel;
    return request;
  }

  static getRemarks(applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/gohonzons/applications/${applicationId}/remarks`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Gohonzon.getRemarks.cancel = request.cancel;
    return request;
  }

  static submitInterViewByRegionSi(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/applications/${applicationId}/interview`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.submitInterViewByRegionSi.cancel = request.cancel;
    return request;
  }

  static gohonzonReject(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/cancel`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.gohonzonReject.cancel = request.cancel;
    return request;
  }

  static batchHandover(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/application-batches/${data.id}/handover`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.batchHandover.cancel = request.cancel;
    return request;
  }

  static applicationHandover(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/gohonzons/applications/${data.id}/handover`, {
      accessToken: accessTokenFromLocal,
      data,
    });
    Gohonzon.applicationHandover.cancel = request.cancel;
    return request;
  }

  static getRegionSiList(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/regionChief`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getRegionSiList.cancel = request.cancel;
    return request;
  }

  static getChapterChiefList(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/chapterChief`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getChapterChiefList.cancel = request.cancel;
    return request;
  }

  static batchConferral(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/application-batches/${data.id}/conferral`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.batchConferral.cancel = request.cancel;
    return request;
  }

  static markIndividualConferral(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/gohonzons/applications/${applicationId}/conferral`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.markIndividualConferral.cancel = request.cancel;
    return request;
  }

  static getHandoverBatchesForRegionSI(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/gohonzons/application-batches-region?status=HANDOVER`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.getHandoverBatchesForRegionSI.cancel = request.cancel;
    return request;
  }

  static GohonzonReturnRequest(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/gohonzonApplications/returnRequest`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.GohonzonReturnRequest.cancel = request.cancel;
    return request;
  }

  static GohonzonReturnVerification(data, applicationId, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/verifyReturnRequest`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.GohonzonReturnVerification.cancel = request.cancel;

    return request;
  }

  static handoverAtHelpdesk(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/returnRequest/handover`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.handoverAtHelpdesk.cancel = request.cancel;
    return request;
  }

  static gohonzonCancelRequest(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/cancelAllotment`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.gohonzonCancelRequest.cancel = request.cancel;
    return request;
  }

  static gohonzonHandoverCancelAllotmentRequest(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/cancelAllotment/handover`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Gohonzon.gohonzonHandoverCancelAllotmentRequest.cancel = request.cancel;
    return request;
  }

  static submitInterViewByZoneSi(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/finalInterview`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.submitInterViewByZoneSi.cancel = request.cancel;
    return request;
  }

  static getConferralCount(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/gohonzon/conferral-count`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getConferralCount.cancel = request.cancel;
    return request;
  }

  static getAllotmentCount(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/gohonzon/allotment-count`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getAllotmentCount.cancel = request.cancel;
    return request;
  }

  static getGohonzonInventoryDetails(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/gohonzonInventory/", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getGohonzonInventoryDetails.cancel = request.cancel;
    return request;
  }

  static getGohonzonMasterInventory({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/gohonzonInventory/fetch", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.getGohonzonMasterInventory.cancel = request.cancel;
    return request;
  }

  static addGohonzonMasterData(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/gohonzonInventory/add/gohonzon/", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.addGohonzonMasterData.cancel = request.cancel;
    return request;
  }

  static GohonzonApplyEligibility(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/gohonzonApplications/eligible`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.GohonzonApplyEligibility.cancel = request.cancel;
    return request;
  }

  static GohonzonDirectEntry(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/gohonzonApplications/direct`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Gohonzon.GohonzonDirectEntry.cancel = request.cancel;
    return request;
  }

  static gohonzonEntryUpdate(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/gohonzons/applications/${applicationId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.gohonzonEntryUpdate.cancel = request.cancel;
    return request;
  }

  static gohonzonDeleteApplication(applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");

    // 👇 payload automatically created here
    const payload = {
      status: "CANCELLED",
      updatedBy: accessMemberIdFromLocal || null, // optional
    };

    const request = put(
      `/api/gohonzons/delete-applications/${applicationId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessTokenFromLocal}`,
          "Content-Type": "application/json",
        },
      }
    );

    Gohonzon.gohonzonDeleteApplication.cancel = request.cancel;
    return request;
  }

  static gohonzonTracking(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/gohonzons/applications/tracking`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.gohonzonTracking.cancel = request.cancel;
    return request;
  }

  static sendGohonzonConsent({ memberId, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/gohonzonApplications/${applicationId}/consent`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Gohonzon.sendGohonzonConsent.cancel = request.cancel;
    return request;
  }

  static createSingleBatch(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/gohonzons/application-single-batches", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Gohonzon.createSingleBatch.cancel = request.cancel;
    return request;
  }

  static gohonzonEntryDelete(applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/gohonzons/applications-delete/${applicationId}`, {
      accessToken: accessTokenFromLocal,
    });
    Gohonzon.gohonzonEntryDelete.cancel = request.cancel;
    return request;
  }

  static searchMemberById(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");

    const request = post("/api/members/search", {
      accessToken: accessTokenFromLocal,
      data: {
        memberId,
        inOrganisationStructure: true,
      },
      params: {
        page: 0,
        size: 1,
      },
    });

    Gohonzon.searchMemberById.cancel = request.cancel;
    return request;
  }

  static addMemberInBatch({ batchId, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");

    const request = post(
      `/api/gohonzons/application-batches/${batchId}/members`,
      {
        accessToken: accessTokenFromLocal,
        data: {
          memberId,
        },
      }
    );

    Gohonzon.addMemberInBatch.cancel = request.cancel;
    return request;
  }
}
